/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActionFormSection {
    getFixupPrototypeFunction() { return ActionFormSection.fixupPrototype; }

    static newInstance(model: Partial<ActionFormSection>): ActionFormSection {
        let obj = Object.assign(new ActionFormSection(), model);
        ActionFormSection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActionFormSection>): ActionFormSection {
        if (!model) return null;
        return ActionFormSection.newInstance(<ActionFormSection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActionFormSection) {
        if (!obj) return;

        models.ActionFormSection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActionFormSection): boolean {
        Object.setPrototypeOf(obj, ActionFormSection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Section identifier
     */
    id: string;

    /**
     * Section display title
     */
    title: string;

}
